import { ModalService } from '@app/plugins/iview-modal-modify/service';

import AddInternalNumber from '@pbx/components/numbers/modals/add-internal';
import i18n from '@app/plugins/i18n';
import { NumberService } from '@pbx/services/NumberService';

class NumberModalService extends ModalService {
  constructor() {
    super(NumberService);
  }

  remove(id, item) {
    return this.$removeItem(id, item, {
      content: i18n.t('pbx.number.modal.remove.content', {
        number: `<strong>${item.number}</strong>`
      })
    });
  }

  create_internal() {
    return this.$open({
      title: i18n.t('pbx.number.list.button.create_internal'),
      width: this.size.confirm,
      render: h =>
        h(AddInternalNumber, {
          on: {
            success: data => {
              this.$emit('success', data);
              this.modal.remove();
            }
          }
        })
    });
  }
}

const instance = new NumberModalService();
export { instance as NumberModalService };
